import { render, staticRenderFns } from "./ModalPdfViewDocs.vue?vue&type=template&id=045e66c9&"
import script from "./ModalPdfViewDocs.vue?vue&type=script&lang=js&"
export * from "./ModalPdfViewDocs.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports